import { ArrowLeft } from "lucide-react"
import { Button } from "shared-web/components/base/control/Button"

import { useSignInContext } from "./SignInContext"
import { SignInLocationCombobox } from "./SignInLocationCombobox"
import {
  StepCard,
  StepCardBody,
  StepCardFooter,
  StepCardTitle,
} from "./StepCard"
import { StepIDInput } from "./StepIDInput"

export interface StepOTPSendProps {
  title: string
  onSubmit: (staffExternalID: string) => void
  isSubmitting: boolean
  errorMessage: string | null
  testId?: string
}

export function StepOTPSend({
  title,
  onSubmit,
  isSubmitting,
  errorMessage,
}: StepOTPSendProps) {
  const { setStep } = useSignInContext()

  return (
    <StepCard>
      <StepCardTitle>{title}</StepCardTitle>
      <StepCardBody className="items-center gap-y-4">
        <SignInLocationCombobox />
        <StepIDInput
          onSubmit={onSubmit}
          isSubmitting={isSubmitting}
          errorMessage={errorMessage}
        />
      </StepCardBody>
      <StepCardFooter>
        <Button
          mode="ghost"
          leftIcon={ArrowLeft}
          className="w-full"
          onClick={() => setStep("key")}
        >
          Use a different sign-in method
        </Button>
      </StepCardFooter>
    </StepCard>
  )
}
